import React from 'react'
import DeletePeople from '../People/DeletePeople'

const DeleteTeacher = () => <DeletePeople kind="teacher" />

export default DeleteTeacher
